module.exports = __webpack_public_path__ + "static/media/IMG_5568.997b0688.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/IMG_5568.png
// module id = 326
// module chunks = 0